import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a007e384"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "instruction-admin" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Eigene Unterweisungen"),
  /*#__PURE__*/_createElementVNode("p", { class: "section-sub" }, "Stellen Sie eine Unterweisung aus mehreren Dokumenten zusammen, weisen Sie sie zu und lassen Sie sie digital bestätigen.")
], -1))
const _hoisted_3 = {
  key: 0,
  class: "empty-state",
  style: {"padding":"48px 0"}
}
const _hoisted_4 = {
  key: 1,
  class: "table-wrap"
}
const _hoisted_5 = { class: "data-table" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Unterweisung"),
    /*#__PURE__*/_createElementVNode("th", null, "Zugewiesen an"),
    /*#__PURE__*/_createElementVNode("th", null, "Bestätigungen"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Aktionen")
  ])
], -1))
const _hoisted_7 = { class: "user-name" }
const _hoisted_8 = { class: "user-email" }
const _hoisted_9 = {
  key: 0,
  class: "ia-cat-badge"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 1,
  class: "muted-text"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "text-end" }
const _hoisted_14 = { style: {"display":"inline-flex","align-items":"center","gap":"8px","justify-content":"flex-end"} }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "12",
    y1: "5",
    x2: "12",
    y2: "19"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "5",
    y1: "12",
    x2: "19",
    y2: "12"
  })
], -1))
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "15",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" })
], -1))
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "15",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  })
], -1))
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "15",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("polyline", { points: "3 6 5 6 21 6" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" })
], -1))
const _hoisted_23 = {
  key: 2,
  class: "empty-state",
  style: {"padding":"48px 0"}
}
const _hoisted_24 = { class: "ia-modal" }
const _hoisted_25 = { class: "ia-modal-title" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "ia-hint",
  style: {"margin-top":"0"}
}, "Wie möchten Sie beginnen?", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ia-start-title" }, "Leer beginnen", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ia-start-sub" }, "Dokumente selbst zusammenstellen", -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "ia-hint",
  style: {"margin":"14px 0 8px"}
}, "oder aus einer MEDA-Vorlage:", -1))
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "ia-start-title" }
const _hoisted_33 = { class: "ia-start-sub" }
const _hoisted_34 = { class: "ia-modal-footer" }
const _hoisted_35 = { class: "field" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "field-label",
  for: "ia-title-input"
}, [
  /*#__PURE__*/_createTextVNode("Name der Unterweisung "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1))
const _hoisted_37 = { class: "field" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "field-label",
  for: "ia-cat-input"
}, "Kategorie", -1))
const _hoisted_39 = { class: "field" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, [
  /*#__PURE__*/_createTextVNode("Dokumente "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1))
const _hoisted_41 = {
  key: 0,
  class: "ia-doc-list"
}
const _hoisted_42 = ["onDragover", "onDrop"]
const _hoisted_43 = ["onDragstart"]
const _hoisted_44 = /*#__PURE__*/_createStaticVNode("<svg width=\"10\" height=\"16\" viewBox=\"0 0 10 16\" fill=\"currentColor\" aria-hidden=\"true\" data-v-a007e384><circle cx=\"2.5\" cy=\"3\" r=\"1.3\" data-v-a007e384></circle><circle cx=\"7.5\" cy=\"3\" r=\"1.3\" data-v-a007e384></circle><circle cx=\"2.5\" cy=\"8\" r=\"1.3\" data-v-a007e384></circle><circle cx=\"7.5\" cy=\"8\" r=\"1.3\" data-v-a007e384></circle><circle cx=\"2.5\" cy=\"13\" r=\"1.3\" data-v-a007e384></circle><circle cx=\"7.5\" cy=\"13\" r=\"1.3\" data-v-a007e384></circle></svg>", 1)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = ["onUpdate:modelValue"]
const _hoisted_47 = { class: "ia-doc-actions" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "15",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" }),
  /*#__PURE__*/_createElementVNode("polyline", { points: "15 3 21 3 21 9" }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "10",
    y1: "14",
    x2: "21",
    y2: "3"
  })
], -1))
const _hoisted_50 = ["onClick"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "15",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("polyline", { points: "3 6 5 6 21 6" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" })
], -1))
const _hoisted_52 = {
  key: 1,
  class: "ia-file-readonly",
  style: {"margin-bottom":"10px"}
}
const _hoisted_53 = { class: "ia-add-row" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = ["disabled"]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ia-hint" }, " Die Zuweisung an Gruppen oder Mitarbeitende erfolgt anschließend in den Tabs „Gruppen\" bzw. „Mitarbeiter\" – wie bei Kursen. ", -1))
const _hoisted_57 = {
  key: 0,
  class: "ia-error"
}
const _hoisted_58 = { class: "ia-modal-footer ia-modal-footer--split" }
const _hoisted_59 = ["disabled"]
const _hoisted_60 = { class: "field" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "field-label",
  for: "ia-legacy-title"
}, [
  /*#__PURE__*/_createTextVNode("Name der Unterweisung "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1))
const _hoisted_62 = { class: "field ia-file-readonly" }
const _hoisted_63 = { class: "field" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Zu bestätigende Punkte", -1))
const _hoisted_65 = ["onUpdate:modelValue"]
const _hoisted_66 = ["onClick"]
const _hoisted_67 = {
  key: 0,
  class: "ia-error"
}
const _hoisted_68 = { class: "ia-modal-footer ia-modal-footer--split" }
const _hoisted_69 = ["disabled"]
const _hoisted_70 = { class: "ia-modal ia-modal-sm" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "ia-modal-title" }, "Unterweisung löschen", -1))
const _hoisted_72 = { class: "ia-confirm-text" }
const _hoisted_73 = {
  key: 0,
  class: "ia-error"
}
const _hoisted_74 = { class: "ia-modal-footer ia-modal-footer--split" }
const _hoisted_75 = ["disabled"]
const _hoisted_76 = ["disabled"]
const _hoisted_77 = { class: "ia-modal" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "ia-modal-title" }, "MEDA-Dokument hinzufügen", -1))
const _hoisted_79 = {
  key: 0,
  class: "ia-baustein-list"
}
const _hoisted_80 = { class: "ia-baustein-title" }
const _hoisted_81 = ["onClick"]
const _hoisted_82 = {
  key: 1,
  class: "ia-file-readonly"
}
const _hoisted_83 = { class: "ia-modal-footer" }
const _hoisted_84 = { class: "ia-modal" }
const _hoisted_85 = { class: "ia-modal-title" }
const _hoisted_86 = {
  key: 0,
  class: "list-popup-items"
}
const _hoisted_87 = { class: "lp-row" }
const _hoisted_88 = { class: "lp-col" }
const _hoisted_89 = { class: "lp-label" }
const _hoisted_90 = { class: "lp-sub" }
const _hoisted_91 = ["onClick"]
const _hoisted_92 = {
  key: 1,
  class: "empty-state",
  style: {"padding":"16px 0"}
}
const _hoisted_93 = { class: "ia-modal-footer" }
const _hoisted_94 = { class: "ia-modal" }
const _hoisted_95 = { class: "ia-modal-title" }
const _hoisted_96 = {
  key: 0,
  class: "list-popup-items"
}
const _hoisted_97 = { class: "lp-label" }
const _hoisted_98 = { class: "lp-sub" }
const _hoisted_99 = {
  key: 1,
  class: "empty-state",
  style: {"padding":"16px 0"}
}
const _hoisted_100 = { class: "ia-modal-footer" }

import { ref, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from '@/store';
import DotMenu from './DotMenu.vue';
import { getGroups } from '@training24/organisation/src/group';
import { getAll as getPermissions } from '@training24/organisation/src/permission';
import { index as getProfiles } from '@training24/user/src/profilePermissions';
import type { Instruction, InstructionConfirmation } from '@/store/instruction';
import type { InstructionContent } from '@/store/instructionContent';

interface DocRow { contentId: string; contentOrg: string; title: string; owner: 'MEDA' | 'ORG' }


export default /*#__PURE__*/_defineComponent({
  __name: 'InstructionAdmin',
  setup(__props) {

const ACCEPT = 'application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document';

const store = useStore();
const router = useRouter();

const loading = ref(true);
const groupNameById = ref<Record<string, string>>({});
const userNameById = ref<Record<string, string>>({});

const instructions = computed<Instruction[]>(() => store.getters['instruction/getAll']);
const templates = computed<Instruction[]>(() => store.getters['instruction/getTemplates']);
const usableLibrary = computed<InstructionContent[]>(() => store.getters['instructionContent/getUsable']);
const libraryById = computed<Record<string, InstructionContent>>(() => {
  const map: Record<string, InstructionContent> = {};
  usableLibrary.value.forEach((c) => { map[c.contentId] = c; });
  return map;
});
const orgId = computed<string>(() => store.getters['organisation/getOrganisationId']);

onMounted(async () => {
  try {
    await Promise.all([
      store.dispatch('instruction/LOAD_ALL', { force: true }),
      store.dispatch('instructionContent/LOAD', { force: true }).catch(() => undefined),
      store.dispatch('instruction/LOAD_TEMPLATES', { force: true }).catch(() => undefined),
    ]);
    const id = orgId.value;
    const jwt = store.getters.getJWT;
    if (id) await store.dispatch('courseAssignment/LOAD_ALL', id);

    if (id) {
      const [groups, permissions, profiles] = await Promise.all([
        getGroups(id, jwt).catch(() => [] as any[]),
        getPermissions(id, jwt).catch(() => [] as any[]),
        getProfiles(id, jwt).catch(() => [] as any[]),
      ]);
      const g: Record<string, string> = {};
      (groups as any[]).forEach((x) => { g[x.groupId] = x.name; });
      groupNameById.value = g;

      const nameByProfile: Record<string, string> = {};
      (profiles as any[]).forEach((pf) => {
        if (pf.data && pf.data.first_name) nameByProfile[pf.userId] = `${pf.data.first_name} ${pf.data.last_name}`;
      });
      const u: Record<string, string> = {};
      (permissions as any[]).forEach((perm) => {
        u[perm.userId] = nameByProfile[perm.userId] || perm.userName || perm.email || perm.userId;
      });
      userNameById.value = u;
    }
  } catch (e) {
    // Liste bleibt ggf. leer – Fehler nicht hart anzeigen
  } finally {
    loading.value = false;
  }
});

function subtitle(item: Instruction): string {
  const count = item.sections ? item.sections.length : 0;
  if (count > 0) return `${count} Dokument${count > 1 ? 'e' : ''}`;
  return item.fileName || '—';
}

// ── Anlegen / Bearbeiten ──────────────────────────────────
const modalVisible = ref(false);
const editing = ref<Instruction | null>(null);
const startStep = ref(false);
const saving = ref(false);
const error = ref('');

const docs = ref<DocRow[]>([]);
const form = ref<{ title: string; category: string; fileName: string; confirmationItems: string[] }>({
  title: '',
  category: '',
  fileName: '',
  confirmationItems: [],
});

const legacyEdit = computed<boolean>(() =>
  !!editing.value && !(editing.value.sections && editing.value.sections.length > 0)
);

// MEDA-Dokument-Suche
const mediaSearch = ref<{ open: boolean; query: string }>({ open: false, query: '' });
const mediaResults = computed<InstructionContent[]>(() => {
  const q = mediaSearch.value.query.trim().toLowerCase();
  const chosen = new Set(docs.value.map((d) => d.contentId));
  return usableLibrary.value.filter(
    (c) =>
      c.ownerType === 'MEDA' &&
      !chosen.has(c.contentId) &&
      (!q || c.title.toLowerCase().indexOf(q) >= 0)
  );
});

// Eigener Upload
const uploading = ref(false);
const ownFileInput = ref<HTMLInputElement | null>(null);

function triggerOwnUpload() {
  if (!uploading.value && ownFileInput.value) ownFileInput.value.click();
}

function resetModal() {
  editing.value = null;
  startStep.value = false;
  docs.value = [];
  form.value = { title: '', category: '', fileName: '', confirmationItems: [] };
  error.value = '';
}

function openCreate() {
  resetModal();
  // Start-Auswahl nur zeigen, wenn es Vorlagen gibt; sonst direkt leer beginnen.
  startStep.value = templates.value.length > 0;
  modalVisible.value = true;
}

function startBlank() {
  startStep.value = false;
  docs.value = [];
}

function startFromTemplate(t: Instruction) {
  form.value.title = t.title;
  form.value.category = t.category || '';
  docs.value = [...(t.sections || [])]
    .sort((a, b) => a.order - b.order)
    .map((s) => {
      const c = libraryById.value[s.contentId];
      return {
        contentId: s.contentId,
        contentOrg: s.contentOrg,
        title: s.title || (c ? c.title : 'Dokument'),
        owner: (s.contentOrg === 'MEDA' ? 'MEDA' : 'ORG') as 'MEDA' | 'ORG',
      };
    });
  startStep.value = false;
}

function openEdit(item: Instruction) {
  resetModal();
  editing.value = item;
  form.value.title = item.title;
  form.value.category = item.category || '';
  if (item.sections && item.sections.length > 0) {
    docs.value = [...item.sections]
      .sort((a, b) => a.order - b.order)
      .map((s) => {
        const c = libraryById.value[s.contentId];
        return {
          contentId: s.contentId,
          contentOrg: s.contentOrg,
          title: s.title || (c ? c.title : 'Dokument'),
          owner: (s.contentOrg === 'MEDA' ? 'MEDA' : 'ORG') as 'MEDA' | 'ORG',
        };
      });
  } else {
    form.value.fileName = item.fileName;
    form.value.confirmationItems = [...(item.confirmationItems || [])];
  }
  modalVisible.value = true;
}

function openMediaSearch() {
  mediaSearch.value = { open: true, query: '' };
}

function addMediaDoc(c: InstructionContent) {
  docs.value.push({ contentId: c.contentId, contentOrg: c.organisationId, title: c.title, owner: 'MEDA' });
  mediaSearch.value.open = false;
}

async function onOwnFileSelected(e: Event) {
  const target = e.target as HTMLInputElement;
  const file = target.files && target.files[0];
  target.value = '';
  if (!file) return;
  uploading.value = true;
  error.value = '';
  try {
    const content = await store.dispatch('instructionContent/UPLOAD_OWN_BAUSTEIN', {
      file,
      title: file.name.replace(/\.[^.]+$/, ''),
      confirmationItems: ['Inhalt gelesen und verstanden'],
    });
    docs.value.push({
      contentId: content.contentId,
      contentOrg: content.organisationId || orgId.value,
      title: content.title,
      owner: 'ORG',
    });
  } catch (err: any) {
    error.value = err?.response?.data?.error || 'Das Dokument konnte nicht hochgeladen werden.';
  } finally {
    uploading.value = false;
  }
}

// Reihenfolge der Dokumente: Drag & Drop (Maus) plus ↑/↓ (Tastatur).
const dragIndex = ref<number | null>(null);
const dragOverIndex = ref<number | null>(null);

function move(from: number, to: number) {
  if (to < 0 || to >= docs.value.length || from === to) return;
  const arr = docs.value.slice();
  const [moved] = arr.splice(from, 1);
  arr.splice(to, 0, moved);
  docs.value = arr;
}
function onDragStart(idx: number) {
  dragIndex.value = idx;
}
function onDrop(idx: number) {
  if (dragIndex.value !== null) move(dragIndex.value, idx);
  dragIndex.value = null;
  dragOverIndex.value = null;
}
function onDragEnd() {
  dragIndex.value = null;
  dragOverIndex.value = null;
}

async function save() {
  error.value = '';
  if (!form.value.title.trim()) {
    error.value = 'Bitte geben Sie einen Namen ein.';
    return;
  }

  saving.value = true;
  try {
    if (legacyEdit.value && editing.value) {
      await store.dispatch('instruction/UPDATE', {
        instructionId: editing.value.instructionId,
        payload: {
          title: form.value.title.trim(),
          confirmationItems: form.value.confirmationItems.map((i) => i.trim()).filter((i) => i.length > 0),
        },
      });
    } else {
      if (!docs.value.length) {
        error.value = 'Bitte fügen Sie mindestens ein Dokument hinzu.';
        saving.value = false;
        return;
      }
      if (docs.value.some((d) => !d.title.trim())) {
        error.value = 'Bitte benennen Sie jedes Dokument.';
        saving.value = false;
        return;
      }
      const sections = docs.value.map((d, order) => {
        const base = libraryById.value[d.contentId];
        const name = d.title.trim();
        // Nur als Override speichern, wenn der Name vom Baustein-Titel abweicht.
        const title = name && (!base || name !== base.title) ? name : undefined;
        return { contentId: d.contentId, contentOrg: d.contentOrg, order, title };
      });
      const category = form.value.category.trim();
      if (editing.value) {
        await store.dispatch('instruction/UPDATE_MODULE', {
          instructionId: editing.value.instructionId,
          payload: { title: form.value.title.trim(), category, sections },
        });
      } else {
        await store.dispatch('instruction/CREATE_MODULE', { title: form.value.title.trim(), category, sections });
      }
    }
    modalVisible.value = false;
  } catch (e: any) {
    error.value = e?.response?.data?.error || 'Beim Speichern ist ein Fehler aufgetreten.';
  } finally {
    saving.value = false;
  }
}

const deleteTarget = ref<Instruction | null>(null);
const deleting = ref(false);
const deleteError = ref('');

function remove(item: Instruction) {
  deleteError.value = '';
  deleteTarget.value = item;
}

async function confirmDelete() {
  if (!deleteTarget.value) return;
  deleting.value = true;
  deleteError.value = '';
  try {
    await store.dispatch('instruction/DELETE', deleteTarget.value.instructionId);
    deleteTarget.value = null;
  } catch (e) {
    deleteError.value = 'Löschen fehlgeschlagen. Bitte versuchen Sie es erneut.';
  } finally {
    deleting.value = false;
  }
}

// Ein einzelnes Dokument in neuem Tab öffnen. Fenster synchron öffnen (Popup-Blocker),
// dann die pre-signed URL setzen.
async function openDoc(d: DocRow) {
  const w = window.open('', '_blank');
  try {
    const res = await store.dispatch('instructionContent/GET_DOC_URL', {
      contentId: d.contentId,
      contentOrg: d.contentOrg,
    });
    if (w && res && res.url) w.location.href = res.url;
    else if (w) w.close();
  } catch (e) {
    if (w) w.close();
    window.alert('Dokument konnte nicht geöffnet werden.');
  }
}

// Ganze Unterweisung in der Mitarbeiter-Ansicht (LMS) in neuem Tab öffnen.
function previewInstruction(item: Instruction) {
  const route = router.resolve({ name: 'lmsInstruction', params: { instructionId: item.instructionId } });
  window.open(route.href, '_blank');
}

// ── Bestätigungen ─────────────────────────────────────────
const confModalVisible = ref(false);
const confModalItem = ref<Instruction | null>(null);

const confModalList = computed<InstructionConfirmation[]>(() =>
  confModalItem.value ? store.getters['instruction/getConfirmations'](confModalItem.value.instructionId) : []
);

function confirmationCount(instructionId: string): number {
  return (store.getters['instruction/getConfirmations'](instructionId) as InstructionConfirmation[]).length;
}

async function openConfirmations(item: Instruction) {
  confModalItem.value = item;
  confModalVisible.value = true;
  try {
    await store.dispatch('instruction/LOAD_CONFIRMATIONS', item.instructionId);
  } catch (e) {
    // leer lassen
  }
}

async function downloadCertificate(c: InstructionConfirmation) {
  try {
    const res = await store.dispatch('instruction/GET_CERTIFICATE_URL', {
      instructionId: c.instructionId,
      userId: c.userId,
    });
    if (res && res.url) window.open(res.url, '_blank');
  } catch (e) {
    window.alert('Nachweis konnte nicht erstellt werden.');
  }
}

// ── Helpers ───────────────────────────────────────────────
function instructionAssignments(item: Instruction): any[] {
  return ((store.state as any).courseAssignment?.all || []).filter(
    (a: any) => a.kind === 'INSTRUCTION' && a.instructionId === item.instructionId
  );
}

function targetSummary(item: Instruction): string {
  const list = instructionAssignments(item);
  const g = list.filter((a: any) => a.targetType === 'GROUP').length;
  const u = list.filter((a: any) => a.targetType === 'USER').length;
  const parts: string[] = [];
  if (g) parts.push(`${g} Gruppe${g > 1 ? 'n' : ''}`);
  if (u) parts.push(`${u} Person${u > 1 ? 'en' : ''}`);
  return parts.length ? parts.join(', ') : '—';
}

function assignmentCount(item: Instruction): number {
  return instructionAssignments(item).length;
}

const assigneePopup = ref<{ visible: boolean; title: string; entries: { label: string; sub: string }[] }>({
  visible: false,
  title: '',
  entries: [],
});

function openAssigneesPopup(item: Instruction) {
  const entries = instructionAssignments(item).map((a: any) => {
    if (a.targetType === 'GROUP') {
      return {
        label: groupNameById.value[a.targetId] || 'Gruppe',
        sub: a.deadline ? 'Gruppe · Frist ' + new Date(a.deadline).toLocaleDateString('de-DE') : 'Gruppe',
      };
    }
    return {
      label: userNameById.value[a.targetId] || 'Mitarbeiter:in',
      sub: a.deadline ? 'Mitarbeiter:in · Frist ' + new Date(a.deadline).toLocaleDateString('de-DE') : 'Mitarbeiter:in',
    };
  });
  assigneePopup.value = { visible: true, title: 'Zugewiesen an – ' + item.title, entries };
}

function formatDate(ts: number): string {
  if (!ts) return '';
  const d = new Date(ts);
  return d.toLocaleDateString('de-DE') + ' ' + d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "section-bar" }, [
      _hoisted_2,
      _createElementVNode("button", {
        class: "btn-primary",
        onClick: openCreate
      }, "Neue Unterweisung")
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Wird geladen …"))
      : (_unref(instructions).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("table", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(instructions), (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.instructionId
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1),
                      _createElementVNode("div", _hoisted_8, _toDisplayString(subtitle(item)), 1),
                      (item.category)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(item.category), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, [
                      (assignmentCount(item) > 0)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "count-chip",
                            onClick: ($event: any) => (openAssigneesPopup(item))
                          }, _toDisplayString(targetSummary(item)), 9, _hoisted_10))
                        : (_openBlock(), _createElementBlock("span", _hoisted_11, "—"))
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        class: "count-chip",
                        onClick: ($event: any) => (openConfirmations(item))
                      }, _toDisplayString(confirmationCount(item.instructionId)) + " Bestätigungen ", 9, _hoisted_12)
                    ]),
                    _createElementVNode("td", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("button", {
                          class: "btn-ghost small",
                          onClick: ($event: any) => (_ctx.$emit('assign', item.instructionId))
                        }, [
                          _hoisted_16,
                          _createTextVNode(" Zuweisen ")
                        ], 8, _hoisted_15),
                        _createVNode(DotMenu, null, {
                          default: _withCtx(() => [
                            _createElementVNode("button", {
                              class: "dot-menu-item",
                              onClick: ($event: any) => (openEdit(item))
                            }, [
                              _hoisted_18,
                              _createTextVNode(" Bearbeiten ")
                            ], 8, _hoisted_17),
                            _createElementVNode("button", {
                              class: "dot-menu-item",
                              onClick: ($event: any) => (previewInstruction(item))
                            }, [
                              _hoisted_20,
                              _createTextVNode(" Vorschau ")
                            ], 8, _hoisted_19),
                            _createElementVNode("button", {
                              class: "dot-menu-item danger",
                              onClick: ($event: any) => (remove(item))
                            }, [
                              _hoisted_22,
                              _createTextVNode(" Löschen ")
                            ], 8, _hoisted_21)
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_23, " Noch keine eigenen Unterweisungen angelegt. ")),
    (modalVisible.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "ia-backdrop",
          onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (modalVisible.value = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("h3", _hoisted_25, _toDisplayString(editing.value ? 'Unterweisung bearbeiten' : 'Neue Unterweisung'), 1),
            (startStep.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_26,
                  _createElementVNode("button", {
                    class: "ia-start-option",
                    onClick: startBlank
                  }, _hoisted_29),
                  (_unref(templates).length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_30,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(templates), (t) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: t.instructionId,
                            class: "ia-start-option",
                            onClick: ($event: any) => (startFromTemplate(t))
                          }, [
                            _createElementVNode("span", _hoisted_32, _toDisplayString(t.title), 1),
                            _createElementVNode("span", _hoisted_33, _toDisplayString((t.sections || []).length) + " Dokument(e) · anpassbar", 1)
                          ], 8, _hoisted_31))
                        }), 128))
                      ], 64))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("button", {
                      class: "btn-ghost",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (modalVisible.value = false))
                    }, "Abbrechen")
                  ])
                ], 64))
              : (!_unref(legacyEdit))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _withDirectives(_createElementVNode("input", {
                        id: "ia-title-input",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.title) = $event)),
                        type: "text",
                        class: "ia-input",
                        placeholder: "z. B. Hygiene"
                      }, null, 512), [
                        [_vModelText, form.value.title]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _withDirectives(_createElementVNode("input", {
                        id: "ia-cat-input",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.category) = $event)),
                        type: "text",
                        class: "ia-input",
                        placeholder: "z. B. Pflege & Gesundheit"
                      }, null, 512), [
                        [_vModelText, form.value.category]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _hoisted_40,
                      (docs.value.length)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_41, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(docs.value, (d, idx) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: idx,
                                class: _normalizeClass(["ia-doc-row", { dragover: dragOverIndex.value === idx }]),
                                onDragover: _withModifiers(($event: any) => (dragOverIndex.value = idx), ["prevent"]),
                                onDragleave: _cache[3] || (_cache[3] = ($event: any) => (dragOverIndex.value = null)),
                                onDrop: ($event: any) => (onDrop(idx))
                              }, [
                                _createElementVNode("span", {
                                  class: "ia-drag",
                                  draggable: "true",
                                  title: "Ziehen zum Sortieren",
                                  onDragstart: ($event: any) => (onDragStart(idx)),
                                  onDragend: onDragEnd
                                }, _hoisted_45, 40, _hoisted_43),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => ((d.title) = $event),
                                  class: "ia-input ia-doc-name",
                                  type: "text",
                                  placeholder: "Dokumentname"
                                }, null, 8, _hoisted_46), [
                                  [_vModelText, d.title]
                                ]),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["ia-badge", { meda: d.owner === 'MEDA' }])
                                }, _toDisplayString(d.owner === 'MEDA' ? 'MEDA' : 'Upload'), 3),
                                _createElementVNode("div", _hoisted_47, [
                                  _createVNode(DotMenu, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("button", {
                                        class: "dot-menu-item",
                                        onClick: ($event: any) => (openDoc(d))
                                      }, [
                                        _hoisted_49,
                                        _createTextVNode(" Vorschau ")
                                      ], 8, _hoisted_48),
                                      _createElementVNode("button", {
                                        class: "dot-menu-item danger",
                                        onClick: ($event: any) => (docs.value.splice(idx, 1))
                                      }, [
                                        _hoisted_51,
                                        _createTextVNode(" Entfernen ")
                                      ], 8, _hoisted_50)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ])
                              ], 42, _hoisted_42))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_52, "Noch keine Dokumente hinzugefügt.")),
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("button", {
                          class: "btn-ghost small",
                          disabled: uploading.value,
                          onClick: openMediaSearch
                        }, "+ MEDA-Dokument", 8, _hoisted_54),
                        _createElementVNode("button", {
                          class: "btn-ghost small",
                          disabled: uploading.value,
                          onClick: triggerOwnUpload
                        }, _toDisplayString(uploading.value ? 'Wird hochgeladen …' : '+ Eigenes Dokument'), 9, _hoisted_55),
                        _createElementVNode("input", {
                          ref_key: "ownFileInput",
                          ref: ownFileInput,
                          type: "file",
                          hidden: "",
                          accept: ACCEPT,
                          onChange: onOwnFileSelected
                        }, null, 544)
                      ])
                    ]),
                    _hoisted_56,
                    (error.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_57, _toDisplayString(error.value), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("button", {
                        class: "btn-ghost",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (modalVisible.value = false))
                      }, "Abbrechen"),
                      _createElementVNode("button", {
                        class: "btn-primary",
                        disabled: saving.value || uploading.value,
                        onClick: save
                      }, _toDisplayString(saving.value ? 'Wird gespeichert …' : 'Speichern'), 9, _hoisted_59)
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("div", _hoisted_60, [
                      _hoisted_61,
                      _withDirectives(_createElementVNode("input", {
                        id: "ia-legacy-title",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.title) = $event)),
                        type: "text",
                        class: "ia-input"
                      }, null, 512), [
                        [_vModelText, form.value.title]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_62, [
                      _createTextVNode("Dokument: "),
                      _createElementVNode("strong", null, _toDisplayString(form.value.fileName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_63, [
                      _hoisted_64,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.confirmationItems, (citem, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: idx,
                          class: "ia-item-row"
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((form.value.confirmationItems[idx]) = $event),
                            type: "text",
                            class: "ia-input",
                            placeholder: "Bestätigungspunkt"
                          }, null, 8, _hoisted_65), [
                            [_vModelText, form.value.confirmationItems[idx]]
                          ]),
                          _createElementVNode("button", {
                            class: "ia-icon danger",
                            title: "Entfernen",
                            onClick: ($event: any) => (form.value.confirmationItems.splice(idx, 1))
                          }, "×", 8, _hoisted_66)
                        ]))
                      }), 128)),
                      _createElementVNode("button", {
                        class: "ia-add-item",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (form.value.confirmationItems.push('')))
                      }, "+ Punkt hinzufügen")
                    ]),
                    (error.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_67, _toDisplayString(error.value), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("button", {
                        class: "btn-ghost",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (modalVisible.value = false))
                      }, "Abbrechen"),
                      _createElementVNode("button", {
                        class: "btn-primary",
                        disabled: saving.value,
                        onClick: save
                      }, _toDisplayString(saving.value ? 'Wird gespeichert …' : 'Speichern'), 9, _hoisted_69)
                    ])
                  ], 64))
          ])
        ]))
      : _createCommentVNode("", true),
    (deleteTarget.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "ia-backdrop",
          onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (deleteTarget.value = null), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_70, [
            _hoisted_71,
            _createElementVNode("p", _hoisted_72, " Soll die Unterweisung „" + _toDisplayString(deleteTarget.value.title) + "\" wirklich gelöscht werden? Das lässt sich nicht rückgängig machen. ", 1),
            (deleteError.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_73, _toDisplayString(deleteError.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("button", {
                class: "btn-ghost",
                disabled: deleting.value,
                onClick: _cache[9] || (_cache[9] = ($event: any) => (deleteTarget.value = null))
              }, "Abbrechen", 8, _hoisted_75),
              _createElementVNode("button", {
                class: "btn-danger-solid",
                disabled: deleting.value,
                onClick: confirmDelete
              }, _toDisplayString(deleting.value ? 'Wird gelöscht …' : 'Löschen'), 9, _hoisted_76)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (mediaSearch.value.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 5,
          class: "ia-backdrop",
          onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (mediaSearch.value.open = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_77, [
            _hoisted_78,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((mediaSearch.value.query) = $event)),
              type: "text",
              class: "ia-input",
              placeholder: "Suchen …",
              style: {"margin-bottom":"12px"}
            }, null, 512), [
              [_vModelText, mediaSearch.value.query]
            ]),
            (_unref(mediaResults).length)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_79, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mediaResults), (c) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: c.contentId,
                      class: "ia-baustein-row"
                    }, [
                      _createElementVNode("span", _hoisted_80, _toDisplayString(c.title), 1),
                      _createElementVNode("button", {
                        class: "btn-ghost small",
                        onClick: ($event: any) => (addMediaDoc(c))
                      }, "Hinzufügen", 8, _hoisted_81)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_82, "Keine passenden MEDA-Dokumente gefunden.")),
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("button", {
                class: "btn-ghost",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (mediaSearch.value.open = false))
              }, "Schließen")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (confModalVisible.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 6,
          class: "ia-backdrop",
          onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (confModalVisible.value = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_84, [
            _createElementVNode("h3", _hoisted_85, "Bestätigungen – " + _toDisplayString(confModalItem.value?.title), 1),
            (_unref(confModalList).length)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_86, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(confModalList), (c) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: c.userId
                    }, [
                      _createElementVNode("div", _hoisted_87, [
                        _createElementVNode("div", _hoisted_88, [
                          _createElementVNode("span", _hoisted_89, _toDisplayString(c.userName || c.signatureName), 1),
                          _createElementVNode("span", _hoisted_90, "Bestätigt am " + _toDisplayString(formatDate(c.confirmedAt)), 1)
                        ]),
                        _createElementVNode("button", {
                          class: "ia-link",
                          onClick: ($event: any) => (downloadCertificate(c))
                        }, "Nachweis", 8, _hoisted_91)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_92, "Noch keine Bestätigungen.")),
            _createElementVNode("div", _hoisted_93, [
              _createElementVNode("button", {
                class: "btn-ghost",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (confModalVisible.value = false))
              }, "Schließen")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (assigneePopup.value.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 7,
          class: "ia-backdrop",
          onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (assigneePopup.value.visible = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_94, [
            _createElementVNode("h3", _hoisted_95, _toDisplayString(assigneePopup.value.title), 1),
            (assigneePopup.value.entries.length)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_96, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(assigneePopup.value.entries, (e, i) => {
                    return (_openBlock(), _createElementBlock("li", { key: i }, [
                      _createElementVNode("span", _hoisted_97, _toDisplayString(e.label), 1),
                      _createElementVNode("span", _hoisted_98, _toDisplayString(e.sub), 1)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_99, "Keine Zuweisungen.")),
            _createElementVNode("div", _hoisted_100, [
              _createElementVNode("button", {
                class: "btn-ghost",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (assigneePopup.value.visible = false))
              }, "Schließen")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})